import { AuthService } from "@js/services/AuthService";
import { FeedBackService } from "@js/services/FeedBackService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import { SharedHeadsOfTermsService } from "@js/services/Deal/SharedHeadsOfTermsService";
import {
  ApplicationUser,
  ApplicationUserCrudClient,
  BridgingDeal,
  BridgingDealClient,
  BridgingSubmitOfferRequest,
  CaseLenderStateEnum,
  DealFileAttachment,
  DealFileAttachmentClient,
  DealLender,
  DealLenderClient,
  DealLenderMessage,
  DealLenderMessageClient,
  FeedBack,
  FeedBackClient,
  FileAttachment,
  InterestRateBasis,
  InterestRateTypeEnum,
  MessageRoleEnum,
  ModuleEnum,
  ProductTypeEnum,
  UserClient,
} from "@src/apis/ModularClient";
import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import ProductHelper from "@js/helpers/ProductHelper";
import { DealLenderService } from "@js/services/Deal/DealLenderService";
import { IndexService } from "@js/services/IndexService";
import { BaseHeadsOfTermsController } from "@js/controllers/BaseHeadsOfTermsController";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class BridgingHeadsOfTermsController extends BaseHeadsOfTermsController {
  static $inject = [
    "$routeParams",
    "$rootScope",
    "$location",
    "RoleService",
    "DealLenderMessageClient",
    "DealFileAttachmentClient",
    "$window",
    "BridgingDealClient",
    "DealLenderClient",
    "SelectListService",
    "FeedBackService",
    "FeedBackClient",
    "UserClient",
    "ApplicationUserCrudClient",
    "IndexService",
    "AuthService",
    "SharedHeadsOfTermsService",
    "DealFileAttachmentHelper",
    "DealLenderService",
    "ODataHelper",
    "$timeout",
  ];

  dealLenders: DealLender[];
  showInformationMessage: boolean = false;
  messageContent: string;
  feedbackMessageToLender: string;

  showDirection: boolean = false;

  toggleHoTDetailSection: boolean = false;
  toggleRejectSection: boolean = false;
  toggleWithdrawSection: boolean = false;

  // show different sections to Lender based on which button clicked on Case Dashboard
  showFeedbackSectionLender: boolean = false;
  showHoTDetailSectionLender: boolean = false;
  showRejectSectionLender: boolean = false;
  showWithdrawSectionLender: boolean = false;

  showTsAndCsModal: boolean = false;
  showTsAndCsForm: boolean = false;
  sendingMessage: boolean = false;
  goToUserDashboard: boolean = false;

  currentDeal: BridgingDeal;
  grossLoanCalcVal: number = 0;
  builLoanCalcVal: number = 0;
  landLoanCalcVal: number = 0;
  monetaryLAFee: number = 0;
  monetaryLEFee: number = 0;
  lenderTask: string = "";

  isRejectClicked: boolean = false;
  isWithdrawClicked: boolean = false;
  isConfirmClicked: boolean = false;
  isSubmitClicked: boolean = false;

  //Lender Message
  newChatMessage: string = "";
  showFullMessageId: number;

  //files
  fileUpload: DealFileAttachment[];
  uploadingFiles: FileUploadProgressDTO[] = [];
  openModal: boolean = false;
  module = ModuleEnum.DIP;

  showFullLenderMessage = false;
  showFullBorrowerMessage = false;
  monthlyInterestRate: number = 0;

  isBridging: boolean = true;
  BasisOfInterestRateOptions = [];
  InterestRateTypeOptions = [];

  showLenderFeedBackModal: boolean = false;
  showBrokerFeedBackModal: boolean = false;
  feedBackDTO: FeedBack;
  prevPath: string;
  showAutofill: boolean = false;

  brokerName: string;
  brokerOrganisationName: string;
  lendingForm: ng.IFormController;

  //Deleteing a chat message
  selectedDealLenderMessageDto: DealLenderMessage;
  showdeleteChatMessageModal: boolean = false;
  showConfirmDeleteButton: boolean = false;

  productTypeText: string = null;
  noLenderOrMoreLenderError: boolean = false;

  constructor(
    $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    roleService: RoleService,
    dealLenderMessageClient: DealLenderMessageClient,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    private $window: ng.IWindowService,
    private bridgingDealClient: BridgingDealClient,
    private dealLenderClient: DealLenderClient,
    private selectListService: SelectListService,
    private feedBackService: FeedBackService,
    private feedBackClient: FeedBackClient,
    userService: UserClient,
    applicationUserCrudClient: ApplicationUserCrudClient,
    indexService: IndexService,
    private $auth: AuthService,
    private sharedHeadsOfTermsService: SharedHeadsOfTermsService,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private dealLenderService: DealLenderService,
    oDataHelper: ODataHelper,
    protected $timeout: ng.ITimeoutService,
  ) {
    super(
      $routeParams,
      userService,
      roleService,
      dealLenderMessageClient,
      applicationUserCrudClient,
      indexService,
      oDataHelper,
    );
    if (this.$routeParams.openModule && this.$routeParams.openModule == "withdraw") {
      this.toggleWithdrawSection = true;
    } else if (this.$routeParams.openModule && this.$routeParams.openModule == "reject") {
      this.toggleRejectSection = true;
    } else if (this.$routeParams.openModule) {
      this.toggleFeedbackSection = true;
    }

    /*this.userClient.getCurrentUserAutofill().then(response => {
                this.showAutofill = response;
            });*/

    if (this.$routeParams.dealId && this.$routeParams.DealLenderId) {
      this.dataLoading = true;

      this.bridgingDealClient
        .fetchCustom(this.$routeParams.dealId)
        .then((response) => {
          this.currentDeal = response;
          if (this.currentDeal) {
            this.dealLenderClient
              .fetchByDealId(
                this.$routeParams.dealId,
                this.roleService.getIsLenderVisible(),
                this.$routeParams.DealLenderId,
              )
              .then((response) => {
                this.dealLenders = response;
                if (this.$routeParams.DealLenderId) {
                  if (this.dealLenders.length != 1) {
                    this.noLenderOrMoreLenderError = true;
                    return;
                  }
                  this.currentCaseLender = this.dealLenders[0];
                  this.fileUpload =
                    this.currentDeal.attachments?.filter((f) => {
                      return f.dealLenderId == this.$routeParams.DealLenderId;
                    }) || [];
                  this.calculateGrossLoanValVal();
                  this.calculateBuildLoadCalcVal();
                  this.calculateMonthlyInterestRate();
                  this.calculateGrossLandLoanCalcVal();
                }
              })
              .finally(() => {
                this.populateLenderInformation(this.currentUser);

                // Scroll to the bottom of the page if we're expanding the message notification area
                if (this.toggleFeedbackSection) {
                  // the timeout delay of 100 is a bit of a hack and may not work well on slower networks
                  $timeout(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                  }, 100);
                }
              });
            // this.caseService.updateCaseState(this.currentDeal.id, this.currentDeal.status);
            this.lenderTask = sessionStorage.getItem("lenderTask");
            if (this.lenderTask != null && this.lenderTask.length > 0) {
              switch (this.lenderTask) {
                case "reject":
                  this.showRejectSectionLender = true;
                  break;
                case "withdraw":
                  this.showWithdrawSectionLender = true;
                  break;
                case "feedback":
                  this.showFeedbackSectionLender = true;
                  this.updateCaseLenderMessageReadDatetime();
                  break;
                case "terms":
                  this.showHoTDetailSectionLender = true;
                  break;
                default:
                  break;
              }
            }

            this.productTypeText = ProductHelper.getProductTypeFullName(this.currentDeal.productType);
          } else {
            if ((this.$rootScope as any).selectedUser) {
              this.$location.path("/dashboard");
            }
          }
        })
        .finally(() => {
          this.dataLoading = false;
          this.getCurrentUserAndRoles();
        });
    }

    this.BasisOfInterestRateOptions = this.selectListService.GetInterestRateBasis();
    this.InterestRateTypeOptions = this.selectListService.GetInterestRateType();
  }

  checkingIfUserIsLender() {
    this.dataLoading = true;
    this.roleService
      .isLenderUser()
      .then((response) => {
        this.isLender = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsBroker() {
    this.dataLoading = true;
    this.roleService
      .isBroker()
      .then((response) => {
        this.isBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsAdmin() {
    this.dataLoading = true;
    this.roleService
      .isAdminUser()
      .then((response) => {
        this.isAdmin = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkingIfUserIsClient() {
    this.dataLoading = true;
    this.roleService
      .isClientUser()
      .then((response) => {
        this.isClient = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  /** Redirects to the case dashboard */
  goToCaseDashboard() {
    this.showFeedbackSectionLender = false;
    this.showHoTDetailSectionLender = false;
    this.showRejectSectionLender = false;
    this.showWithdrawSectionLender = false;
    if (
      this.isBroker &&
      this.currentCaseLender &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "bridgingcasedashboard";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/bridgingcasedashboard/" + this.currentDeal.id);
    }
  }

  /** Close modal after send feedback */
  closeModal() {
    this.showDirection = false;
    this.showTsAndCsModal = false;
    this.showInformationMessage = false;
    this.isConfirmClicked = false;
    this.showdeleteChatMessageModal = false;
    if (this.goToUserDashboard) {
      this.$auth.clearSelectedNavMenuAndFilterStorageData();
      this.$location.path("/userdashboard");
      this.goToUserDashboard = false;
      this.showFeedbackSectionLender = false;
      this.showHoTDetailSectionLender = false;
      this.showRejectSectionLender = false;
      this.showWithdrawSectionLender = false;
    }

    if (this.prevPath) {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentDeal.id}`);
      }
    }
  }

  goToLending() {
    if (
      this.isBroker &&
      this.currentCaseLender &&
      !this.currentCaseLender.isLenderReviewComplete &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      this.prevPath = "dealforum";
      this.feedBackDTO.isLenderFeedback = true;
      this.showLenderFeedBackModal = true;
    } else {
      this.$location.path("/dealforum/" + this.currentDeal.id);
    }
  }

  saveUpdatedCaseLender(): void {
    this.dealLenderClient.addUpdate(this.currentCaseLender).then((response) => {
      this.currentCaseLender = response;
      this.messageContent = "Your changes have been saved.";
      this.showInformationMessage = true;
    });
  }

  dummyDIP() {
    this.dealLenderService.dummyDIP(this);
  }

  /** Process the Lender button being clicked*/
  lenderClicked() {
    (this.$rootScope as any).isLender = false; // TODO JLH why is this being set to false?  What if the user is a lender?
    this.$location.path("/lending/" + this.currentDeal.id);
  }

  /** Process the Reject button being clicked*/
  rejectClicked(): void {
    this.isRejectClicked = true;
    this.dealLenderClient
      .rejectCase(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.status = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have rejected their application.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isRejectClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  ///**Process the Withdraw button being clicked */
  withdrawClicked(): void {
    this.isWithdrawClicked = true;
    this.dealLenderClient
      .withdrawHoT(this.currentCaseLender)
      .then((response) => {
        this.currentCaseLender.status = response.caseLenderState;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "The borrower has been notified you have withdrawn terms for their application.";
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong. Please try again.";
        this.isWithdrawClicked = false;
      })
      .finally(() => {
        this.goToUserDashboard = true;
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
      });
  }

  ///**Process the Submit button being clicked */
  submitClicked() {
    this.isConfirmClicked = true;
    this.showTsAndCsModal = true;
  }

  ///**Heads of Terms Submit button clicked event */
  submitHoTClicked() {
    // Close the Heads of Terms' Terms and Conditions modal
    this.showTsAndCsModal = false;
    this.sendingMessage = true;

    var request = {
      dealLender: this.currentCaseLender,
      dealLenderStatus: this.currentCaseLender.status,
    } as BridgingSubmitOfferRequest;

    // Submit the Heads of Terms
    this.dealLenderClient
      .submitOffer(request)
      .then((response) => {
        this.currentCaseLender.status = response.dealLenderStatus;
        this.brokerName = response.dealBrokerName;
        this.brokerOrganisationName = response.dealBrokerOrganisationName;
        this.messageContent = "Thank you for submitting a Decision in Principle.";
        this.goToUserDashboard = true;
      })
      .catch((error) => {
        this.messageContent =
          "Sorry, something went wrong while submitting your Decision in Principle. Please try again.";
        this.isConfirmClicked = false;
      })
      .finally(() => {
        this.currentCaseLender.isBrokerReviewComplete || this.currentDeal.brokerOrganisationId == null || !this.isLender
          ? (this.showInformationMessage = true)
          : this.showBrokerFeedBack();
        this.sendingMessage = false;
      });
  }

  showBrokerFeedBack() {
    this.feedBackDTO.isBrokerFeedback = true;
    this.showBrokerFeedBackModal = true;
  }

  /**
   * Process the Send Feedback button being clicked
   * @param message
   */
  sendChatMessage() {
    this.dataLoading = true;

    let DealChatMessage = {
      message: this.newChatMessage,
      dealId: this.$routeParams.dealId,
      deal: null,
      dealLenderId: this.$routeParams.DealLenderId,
      dealLender: null,
      senderUser: null,
      senderUserId: this.currentUser.id,
      senderRole: this.getSenderMessageRole(),
      recipientRoles: this.isLender ? MessageRoleEnum.Client | MessageRoleEnum.Broker : MessageRoleEnum.Lender,
    } as DealLenderMessage;

    this.dealLenderMessageClient
      .addUpdateCustom(DealChatMessage)
      .then((dealChatMessageResponse) => {
        this.currentCaseLender.dealLenderMessage.push(dealChatMessageResponse);
        this.newChatMessage = null;
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while sending feedback. Please try again.";
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showFullChatMessage(index) {
    this.showFullMessageId = index;
  }

  onFileSelect(files: FileAttachment[], module: ModuleEnum) {
    if (files.length > 0) {
      this.dealFileAttachmentHelper
        .UploadFileListInSync(
          files,
          this.uploadingFiles,
          this.$routeParams.dealId,
          this.fileUpload,
          module,
          this.$routeParams.DealLenderId,
        )
        .then((result) => {
          this.openModal = false;
        });
    }
  }

  downloadFile(file: DealFileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  deleteFile(file: DealFileAttachment) {
    this.fileUpload.splice(this.fileUpload.indexOf(file), 1);
    this.dealFileAttachmentClient.markAsDeleted(file.id).then((result) => { }); //remove on the server
  }

  disableDip() {
    return !this.showActionButtons();
  }

  showActionButtons() {
    if (
      this.currentCaseLender &&
      (this.currentCaseLender.status == CaseLenderStateEnum.Received ||
        this.currentCaseLender.status == CaseLenderStateEnum.Rejected ||
        this.currentCaseLender.status == CaseLenderStateEnum.Offered ||
        this.currentCaseLender.status == CaseLenderStateEnum.Cancelled ||
        this.currentCaseLender.status == CaseLenderStateEnum.Withdrawn)
    ) {
      return true;
    } else {
      return false;
    }
  }

  calculateGrossLoanValVal() {
    var value = 0;

    // for dev exit there is no GDV therefore use either current value or purchase price depending on whether it's owned or being purchased
    if (this.currentDeal.productType == ProductTypeEnum.BridgingDeveloperExit) {
      value = this.currentDeal.currentvalue;
    } else {
      value = this.currentDeal.gdv;
    }

    if (
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan >= 0 &&
      value != null &&
      value >= 0
    ) {
      this.grossLoanCalcVal = parseFloat(((this.currentCaseLender.totalGrossLoan / value) * 100).toFixed(2));
    }

    if (this.currentCaseLender.totalGrossLoan != null && this.currentCaseLender.totalGrossLoan > 0) {
      if (
        this.currentCaseLender.lenderArrangementFeePercent != null &&
        this.currentCaseLender.lenderArrangementFeePercent > 0
      ) {
        this.calculatemonetaryLAFee();
      } else {
        if (this.currentCaseLender.lenderArrangementFee != null && this.currentCaseLender.lenderArrangementFee > 0) {
          this.calculatemonetaryLAPercent();
        }
      }

      if (this.currentCaseLender.lenderExitFeePercent != null && this.currentCaseLender.lenderExitFeePercent > 0) {
        this.calculatemonetaryLEFee();
      } else {
        if (this.currentCaseLender.lenderExitFee != null && this.currentCaseLender.lenderExitFee > 0) {
          this.calculatemonetaryLEPercent();
        }
      }
    }
  }

  calculatemonetaryLAFee() {
    if (
      this.currentCaseLender.lenderArrangementFeePercent != null &&
      this.currentCaseLender.lenderArrangementFeePercent > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFee =
        Math.round(this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderArrangementFeePercent * 100) /
        100;
    }
  }

  calculatemonetaryLAPercent() {
    if (
      this.currentCaseLender.lenderArrangementFee != null &&
      this.currentCaseLender.lenderArrangementFee > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderArrangementFeePercent =
        this.currentCaseLender.lenderArrangementFee / this.currentCaseLender.totalGrossLoan;

      this.currentCaseLender.lenderArrangementFeePercent = parseFloat(
        this.currentCaseLender.lenderArrangementFeePercent.toFixed(4),
      );
    }
  }

  calculatemonetaryLEFee() {
    if (
      this.currentCaseLender.lenderExitFeePercent != null &&
      this.currentCaseLender.lenderExitFeePercent > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderExitFee =
        Math.round(this.currentCaseLender.totalGrossLoan * this.currentCaseLender.lenderExitFeePercent * 100) / 100;
    }
  }

  calculatemonetaryLEPercent() {
    if (
      this.currentCaseLender.lenderExitFee != null &&
      this.currentCaseLender.lenderExitFee > 0 &&
      this.currentCaseLender.totalGrossLoan != null &&
      this.currentCaseLender.totalGrossLoan > 0
    ) {
      this.currentCaseLender.lenderExitFeePercent =
        this.currentCaseLender.lenderExitFee / this.currentCaseLender.totalGrossLoan;
      this.currentCaseLender.lenderExitFeePercent = parseFloat(this.currentCaseLender.lenderExitFeePercent.toFixed(4));
    }
  }

  /**Calculate borrower equity
   */
  calculateBorrowerEquity() {
    var borrowerEquity: number = 0;

    if (this.currentDeal && this.currentCaseLender) {
      if (this.currentDeal.productType == ProductTypeEnum.BridgingPreconstruction) {
        borrowerEquity = this.currentDeal.propertyValue - this.currentCaseLender.totalNetLoan;
      } else if (this.currentDeal.productType == ProductTypeEnum.BridgingDeveloperExit) {
        borrowerEquity = this.currentDeal.propertyValue - this.currentCaseLender.totalGrossLoan;
      } else if (this.currentDeal.productType == ProductTypeEnum.BridgingRefurb) {
        borrowerEquity = this.currentDeal.propertyValue - this.currentCaseLender.landLoan;
      } else if (this.currentDeal.productType == ProductTypeEnum.BridgingPurchaseOrRefinance) {
        borrowerEquity = this.currentDeal.propertyValue - this.currentCaseLender.totalGrossLoan;
      } else {
        borrowerEquity = this.currentDeal.propertyValue - this.currentCaseLender.totalGrossLoan;
      }
    }
    return Number(borrowerEquity);
  }

  /**Calculate true cost */
  calculateTrueCost(): number {
    if (this.currentCaseLender) {
      var trueCost: number =
        +this.currentCaseLender.interestRate / 12 +
        (+this.currentCaseLender.lenderArrangementFeePercent + +this.currentCaseLender.lenderExitFeePercent) /
        +this.currentDeal.loanTermReq;
      return trueCost;
    }
  }

  calculatInterestRate() {
    if (this.monthlyInterestRate) {
      this.currentCaseLender.interestRate = this.monthlyInterestRate * 12;
    }
  }

  calculateMonthlyInterestRate() {
    if (this.currentCaseLender.interestRate) {
      this.monthlyInterestRate = parseFloat((this.currentCaseLender.interestRate / 12).toFixed(4));
    }
  }

  calculateAnnualInterestRate() {
    if (this.monthlyInterestRate) {
      this.currentCaseLender.interestRate = parseFloat((this.monthlyInterestRate * 12).toFixed(4));
    }
  }

  calculateGrossLandLoanCalcVal() {
    if (this.currentCaseLender.landLoan != null && this.currentCaseLender.landLoan >= 0) {
      this.landLoanCalcVal = parseFloat(
        ((this.currentCaseLender.landLoan / this.currentDeal.purchasePrice) * 100).toFixed(2),
      );
    }
  }

  calculateBuildLoadCalcVal() {
    if (this.currentCaseLender.buildLoan != null && this.currentCaseLender.buildLoan >= 0) {
      this.builLoanCalcVal = parseFloat(
        ((this.currentCaseLender.buildLoan / this.currentDeal.buildCosts) * 100).toFixed(2),
      );
    }
  }

  /**Calculate the Total Net Loan */
  calculateTotalNetLoan() {
    var totalNetLoan: number = 0;
    if (this.currentCaseLender && this.currentCaseLender.buildLoan && this.currentCaseLender.landLoan) {
      totalNetLoan = +this.currentCaseLender.buildLoan + +this.currentCaseLender.landLoan;
      totalNetLoan = Math.round(totalNetLoan * 100) / 100;
    }
    return totalNetLoan;
  }

  getRateTypeText(e: InterestRateTypeEnum) {
    switch (e) {
      case InterestRateTypeEnum.Fixed:
        return "Fixed";
      case InterestRateTypeEnum.Variable:
        return "Variable";
      default:
        break;
    }
  }

  getBasisInterestRateText(e: InterestRateBasis) {
    switch (e) {
      case InterestRateBasis.BaseRate:
        return "Base rate";
      case InterestRateBasis.LendersOwnSVR:
        return "own SVR";
      case InterestRateBasis.Sonia:
        return "Sonia";
      default:
        break;
    }
  }

  addClass(star: number, id: string) {
    this.feedBackService.addClass(star, id);
  }

  removeClass(star: number, id: string, rating) {
    this.feedBackService.removeClass(star, id, rating);
  }

  isFeedBackFormDisabled() {
    return this.feedBackService.isFeedBackFormDisabled(this.isLender, this.feedBackDTO);
  }

  updateRating(star, rating) {
    this.feedBackDTO = this.feedBackService.updateRating(star, rating, this.feedBackDTO);
  }

  submitFeedBack() {
    if (this.isLender) {
      this.feedBackDTO.organisationId = this.currentDeal.brokerOrganisationId;
      this.feedBackDTO.brokerUserId = this.currentDeal.brokerUserId;
      this.feedBackDTO.organisation = null;
      this.feedBackDTO.brokerUser = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    } else {
      this.feedBackDTO.lenderId = this.currentCaseLender.lenderId;
      this.feedBackDTO.lender = null;
      this.feedBackDTO.reviewerUserId = 0;
      this.feedBackDTO.reviewerUser = null;
    }

    this.feedBackClient.addFeedBack(this.currentCaseLender.id, true, this.feedBackDTO).then((response) => {
      if (this.isLender) {
        this.$auth.clearSelectedNavMenuAndFilterStorageData();
        this.$location.path("/userdashboard");
      } else {
        this.$location.path(`/${this.prevPath}/${this.currentDeal.id}`);
      }
    });
  }

  onClickDeleteMessageButton(message: DealLenderMessage) {
    this.showdeleteChatMessageModal = true;
    this.messageContent = "Are you sure you want to delete a selected message?";
    this.selectedDealLenderMessageDto = message;
    this.showConfirmDeleteButton = true;
  }

  deleteChatMessage() {
    this.dataLoading = true;
    this.dealLenderMessageClient
      .markAsDeleted(this.selectedDealLenderMessageDto.id)
      .then((response) => {
        this.currentCaseLender.dealLenderMessage = this.currentCaseLender.dealLenderMessage.filter(
          (x) => x.id != this.selectedDealLenderMessageDto.id,
        );
      })
      .catch((error) => {
        this.messageContent = "Sorry, something went wrong while deleting message. Please try again.";
      })
      .finally(() => {
        this.showdeleteChatMessageModal = false;
        delete this.selectedDealLenderMessageDto;
        this.showConfirmDeleteButton = false;
        this.dataLoading = false;
      });
  }

  getSenderMessageRole() {
    if (this.isLender) {
      return MessageRoleEnum.Lender;
    } else if (this.isBroker) {
      return MessageRoleEnum.Broker;
    } else if (this.isAdmin) {
      return MessageRoleEnum.Admin;
    } else if (this.isClient) {
      return MessageRoleEnum.Client;
    }
  }

  isCurrentUserAllowedToSendChat() {
    if (this.currentUser && this.currentDeal && (this.toggleFeedbackSection || this.showFeedbackSectionLender)) {
      return this.sharedHeadsOfTermsService.isCurrentUserAllowedToSendChat(
        this.isBroker,
        this.currentDeal.status,
        this.currentDeal.isReferredToConnect,
        this.currentUser.isConnectUser,
      );
    }
    return false;
  }
}
